export const CREATE_CONTACT_US = 'api/contact/post'
export const GET_CONTACT_US = 'api/contact/get/unseen'
export const CONTACT_MARK_AS_SEEN = 'api/contact/mark_as_seen'
